module.exports = __webpack_public_path__ + "static/media/7.Spare parts.647847f4.jpeg";